import React, { useState, useEffect } from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { socketService } from '../../services/socket.service';
import { useAuth } from '../../hooks/useAuth';

interface PresenceBarProps {
  sessionId: string;
  currentPage: string;
}

const PresenceBar: React.FC<PresenceBarProps> = ({ sessionId, currentPage }) => {
  const { user } = useAuth();
  const [otherInstructors, setOtherInstructors] = useState<Array<{ instructorId: string; name: string; page: string }>>([]);

  useEffect(() => {
    socketService.emitPresence(sessionId, currentPage);

    const unsub = socketService.onPresenceUpdate((data) => {
      setOtherInstructors(data.instructors.filter((i) => i.instructorId !== user?.id));
    });

    return unsub;
  }, [sessionId, currentPage, user?.id]);

  if (otherInstructors.length === 0) return null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5, px: 2, bgcolor: 'rgba(25, 118, 210, 0.08)', borderRadius: 1, mb: 2 }}>
      <Typography variant="caption" color="text.secondary" sx={{ mr: 0.5 }}>
        Also monitoring:
      </Typography>
      {otherInstructors.map((inst) => (
        <Chip
          key={inst.instructorId}
          size="small"
          avatar={<Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#4caf50' }} component="span" />}
          label={`${inst.name} (${inst.page})`}
          variant="outlined"
          sx={{ height: 24 }}
        />
      ))}
    </Box>
  );
};

export default PresenceBar;
